var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-popover',_vm._b({ref:"popover",attrs:{"popper-class":_vm.computedClass,"disabled":_vm.disabled,"placement":_vm.placement,"width":_vm.width,"transition":_vm.transition,"visible-arrow":_vm.visibleArrow,"trigger":_vm.trigger,"popper-options":{
    boundariesElement: 'viewport',
    gpuAcceleration: false,
    modifiers: [
      'shift',
      'offset',
      _vm.setCustomStyle,
      'preventOverflow',
      'keepTogether',
      'arrow',
      'flip',
      'applyStyle'
    ]
  }},on:{"show":function($event){return _vm.$emit('show')},"hide":function($event){return _vm.$emit('hide')}},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},'el-popover',_vm.$attrs,false),[_vm._t("default"),_c('template',{slot:"reference"},[_vm._t("reference")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }